import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=32819fd4&scoped=true&"
var script = {}
import style0 from "./Archive.vue?vue&type=style&index=0&id=32819fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32819fd4",
  null
  
)

export default component.exports